import NetworkAdmin from '@/helpers/networking/NetworkAdmin';
import { adminApi } from '@/includes/contentManagementApi';

export default {
  /**
   * upload config data
   * @param {Object} configData - The config data
   */
  uploadConfig(assessmentData) {
    return NetworkAdmin.uploadConfig(assessmentData);
  },

  /**
   * Get current config settings from new backend
   * @returns {Promise} API response with config settings
   */
  getConfig() {
    return adminApi.get('/config/settings');
  },

  /**
   * Update config settings in new backend
   * @param {Object} configData - The config settings to update
   * @returns {Promise} API response
   */
  updateConfig(configData) {
    return adminApi.patch('/config/settings', configData);
  },

  /**
   * Get dev tip delivery mode (parallel | alternate)
   * @returns {Promise} API response with { data: { devTipDeliveryMode } }
   */
  getDevTipDeliveryMode() {
    return adminApi.get('/config/dev-tip-delivery-mode');
  },

  /**
   * Update dev tip delivery mode
   * @param {'parallel'|'alternate'} devTipDeliveryMode
   * @returns {Promise} API response
   */
  updateDevTipDeliveryMode(devTipDeliveryMode) {
    return adminApi.patch('/config/dev-tip-delivery-mode', { devTipDeliveryMode });
  },
};
